export const accountId = 53;
export const debugKey = 'USAGE_TRACKER_JS';
export const hstcKey = '__hstc';
export const hamplitudeKey = '__hmpl';
export const storageKey = `HUBLYTICS_EVENTS_${accountId}`;
export const recorderEnabled = 'USAGE_TRACKER_JS_RECORDER_ENABLED';
export const recordedEvents = 'USAGE_TRACKER_JS_RECORDED_EVENTS';
export const recordedEventKeys = 'USAGE_TRACKER_JS_RECORDED_EVENT_KEYS';